export class Media {
  constructor(
    public readonly mediaType: 'IMAGE' | 'VIDEO' | 'CAROUSEL_ALBUM',
    public readonly mediaUrl: string,
    public readonly id: string,
    public readonly children: Media[]
  ) {}
}
